import React from "react";
import {IconButton,Typography,Link} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import useStyles from './Styles'


const DrawerMenu=({setMenuState})=>{
   const classes = useStyles();
return(
    <div className={classes.container}>
        <div className={classes.header}>
            <Typography variant={"h3"} className={classes.logo}>
                Vr Logo
            </Typography>
            <IconButton className={classes.close} onClick={ ()=>{
                setMenuState(false);
            }}>
                <CloseIcon className={classes.icon}/>
            </IconButton>
        </div>
        <div >
                <Typography variant={"h2"} className={classes.body}>
                    <Link href='#' underline='none' className={classes.link}>Home</Link>
                    <Link href='#' underline='none' className={classes.link}>About</Link>
                    <Link href='#' underline='none' className={classes.link}>Mission</Link>
                    <Link href='#' underline='none' className={classes.link}>Projects</Link>
                    <Link href='#' underline='none' className={classes.link}>Contact</Link>
                </Typography>
        </div>
    </div>
)
}
export default DrawerMenu;